import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";

const Contact = () => {
  return (
      <div>
        <Breadcrumbs title="Na kontaktoni"/>
        <div className="container py-16 ">
          <div className="pb-8">
            <h1 className="text-4xl font-bold font-Roboto">
              Dërgo një <span className="text-primary">Mesazh</span>{" "}{" "}
            </h1>
            <p className="text-gray-400 py-2">
              Keni një pyetje apo thjesht doni të na përshëndetni? Do të donim të dëgjonim nga ju.
            </p>
          </div>
          <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-6 gap-2 justify-between">
            <div className="">
              <div className="">
                <fieldset>
                  <label for="fname">Emër Mbiemër:</label>
                  <input
                      className="border-opacity-100 w-full border px-4 border-gray-800 py-2"
                      type="text"
                      id="name"
                      name="name"
                  />
                  <br/>
                  <br/>
                  <label for="email">Email:</label>
                  <input
                      className="border-opacity-100 w-full border px-4 border-gray-800 py-2"
                      type="email"
                      id="email"
                      name="email"
                  />
                  <br/>
                  <br/>
                  <label for="message">Mesazhi:</label>
                  <textarea
                      className="border-opacity-100 w-full border px-4 border-gray-800 py-2"
                      rows="4"
                      cols="50"
                  />
                  <br/>
                  <button
                      className="bg-white mt-4 border border-primary text-black py-3 px-6 rounded-md hover:bg-transparent hover:bg-primary hover:text-white transition">
                    Dërgo
                  </button>
                </fieldset>
              </div>
            </div>
            <div className="inset-0 lg:px-16 px-8">
              <h1 className="text-4xl py-2 font-Poppins font-semibold">
                Na <span className="text-primary">Kontaktoni</span>
              </h1>
              <div className="flex py-4">
                <div className="">
                  <i class="fas fa-map-marker-alt text-3xl text-secondary"></i>
                </div>
                <div className="px-8">
                  <p>Rr. Sadik Petrela Nr.4</p>
                </div>
              </div>
              <div className="flex py-4">
                <div className="">
                  <i className="far fa-envelope text-3xl text-secondary"></i>
                </div>
                <div className="px-8">
                  <p>lirzadental@gmail.com</p>
                </div>
              </div>
              <div className="flex py-4">
                <div className="">
                  <i className="fas fa-phone text-3xl text-secondary"></i>
                </div>
                <div className="px-8 font-bold">
                  <p>+ 355 696272018</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <iframe
            className="w-full h-96"
            width="100%"
            height="100%"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            title="map"
            scrolling="no"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d260.84389034136865!2d19.841366573546253!3d41.337541389035216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135031460c4f1401%3A0x5d6db38374e6a62!2sRruga%20Sadik%20Petrela%202%2C%20Tiran%C3%AB%2C%20Albania!5e0!3m2!1sen!2s!4v1749498823785!5m2!1sen!2s"
        ></iframe>
      </div>
  );
};

export default Contact;
